import { useContext, useRef, useState } from 'react';
import Cross from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../Features/inventoryManagementSlice';
import AddBlue from '../../../../Assets/Modals/AddBlue.svg';
import { toCamelCase } from '../../../../lib/utils/utils';
import { InventoryEditProductFormContext } from '../../../../Context/InventoryEditProductFormContext';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';
import { showToast } from '../../../../Components/Toaster/Toaster';
import Input from '../../../../Components/Input/Input';

function AddCustomField() {
    const dispatch = useDispatch();

    const containerRef = useRef(null);

    useOutsideClickHandler(containerRef, () => {
        dispatch(closeModal());
    });

    const { additionalSpecifications, setAdditionalSpecifications } = useContext(InventoryEditProductFormContext);

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const defaultOptionList = [
        {
            id: 'optionValue1',
            value: ''
        }
    ]

    const [optionList, setOptionList] = useState(defaultOptionList);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setOptionList(prevOptions => 
            prevOptions.map(option => 
                option.id === name ? { ...option, value } : option
            )
        );
    }

    const handleAddOption = () => {
        setOptionList([ ...optionList, { id: `optionValue${optionList.length+1}`, value: '' } ]);
    }

    const handleSave = () => {
        let result = [];
        let allValid = true;

        for(const option of optionList) {
            if(!option.value.trim()) {
                showToast('Please add a field name.', 'warning');
                allValid = false;
            }
            else {
                let customFieldObject = {
                    labelText: option.value,
                    id: toCamelCase(option.value),
                    value: '',
                }

                result.push(customFieldObject);
            }
        }

        if(allValid) {
            setAdditionalSpecifications([ ...additionalSpecifications, ...result ]);
            dispatch(closeModal());
        }
    }

    return (
        <div ref={containerRef} className='w-[44%] h-fit p-6 pt-[18px] flex flex-col gap-6 rounded-xl bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D]'>
            <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between">
                    <p className='font-semibold text-2xl text-[#121212]'>Add Custom Field</p>

                    <button onClick={handleCloseModal} className="outline-none w-11 h-11 flex items-center justify-center">
                        <img src={Cross} alt="" />
                    </button>
                </div>

                <div className="flex flex-col gap-3">
                    {optionList.map(option => {
                        return (
                            <Input 
                                key={option.id} 
                                labelText='Input value' 
                                inputOptions={{
                                    type: 'text',
                                    id: option.id,
                                    name: option.id,
                                    placeholder: 'enter value',
                                    value: option.value,
                                    onChange: handleChange
                                }}
                            />
                        );
                    })}

                    <button onClick={handleAddOption} className='w-fit flex items-center'>
                        <div className="w-6 h-6 flex items-center justify-center">
                            <img src={AddBlue} alt="" />
                        </div>

                        <p className='font-medium text-base text-[#1055EB]'>Add option</p>
                    </button>
                </div>
            </div>
            
            <button onClick={handleSave} className='cursor-pointer px-4 py-2 rounded bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText'>Save</button>
        </div>
    );
}

export default AddCustomField;
